export default __webpack_public_path__ + "static/media/B_Forms.a48dbb23.png";